import React, { Component } from 'react';
import { 
  MuiThemeProvider,
  createMuiTheme
} from '@material-ui/core/styles'
import Main from './Main'
//import SempliciraPro from './fonts/SemplicitaPro.otf'

const theme = createMuiTheme({
  typography: {
    useNextVariants: true,
    fontFamily:[
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
  },
  palette: {
    primary: {
      main: '#000000'

    },
    secondary: {
      main: '#FDE709'
    },
    common: {
      yellow: '#e6ddab'
    }
  }
})


class App extends Component {

  render() {
    return (

      <MuiThemeProvider theme = {theme}>
        <Main/>
      </MuiThemeProvider>
     
    );
  }
}

export default App;
